import { Paper, styled } from '@/shared/ui/mui';
/**
 * @deprecated Prefer `DashboardFilterBar` from `@/shared/ui/dashboard` for dashboard pages.
 *
 * FilterSection - Container for filter controls
 *
 * An elevated paper component designed to contain filter controls
 * and options. Features rounded corners and subtle shadow.
 *
 * @example
 * ```tsx
 * <FilterSection>
 *   <Typography variant="h6">Filters</Typography>
 *   <Box>{filterControls}</Box>
 * </FilterSection>
 * ```
 */
export const FilterSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: '16px',
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.grey[200]}`,
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
}));
